import React, { createContext, useEffect, useState } from 'react'
import { LegalFormalityType } from '../types'

export interface CurrentLegalFormalityContextProviderProps {
  currentLegalFormality: LegalFormalityType
  legalFormalityLoading: boolean
  legalFormalityRefetch: any
  children: any
}

export interface ICurrentLegalFormalityContextValue {
  legalFormality: LegalFormalityType
  legalFormalityLoading: boolean
  legalFormalityRefetch: any
  currentTab: string
  setCurrentTab: any
}

export const CurrentLegalFormalityContext = createContext(
  {} as ICurrentLegalFormalityContextValue
)

const CurrentLegalFormalityContextProvider = (
  props: CurrentLegalFormalityContextProviderProps
) => {
  const {
    currentLegalFormality,
    legalFormalityLoading,
    legalFormalityRefetch,
  } = props
  const isFormStep =
    ['paid', 'form_sent', 'form_received'].indexOf(
      currentLegalFormality.status
    ) !== -1
  const [currentTab, setCurrentTab] = useState(isFormStep ? 'Form' : 'Docs')

  return (
    <CurrentLegalFormalityContext.Provider
      value={{
        legalFormality: currentLegalFormality,
        legalFormalityLoading: legalFormalityLoading,
        legalFormalityRefetch: legalFormalityRefetch,
        currentTab: currentTab,
        setCurrentTab: setCurrentTab,
      }}
    >
      {props.children}
    </CurrentLegalFormalityContext.Provider>
  )
}

export default CurrentLegalFormalityContextProvider
